import { Navigate } from 'react-router-dom';

const STORAGE_KEY = '1goss-entered';

export function RootRedirect() {
  const entered =
    typeof window !== 'undefined' && sessionStorage.getItem(STORAGE_KEY) === '1';
  return <Navigate to={entered ? '/home' : '/welcome'} replace />;
}
